import Upload from './Upload';
import Dragger from './Dragger';

Upload.Dragger = Dragger;
export default Upload;



// WEBPACK FOOTER //
// ./components/upload/index.tsx